import Vue from 'vue';
import CookieRenew from './cookie-renew';

// Main component
Vue.component('cookie-renew', CookieRenew);

export default CookieRenew;


// WEBPACK FOOTER //
// ./scripts/cookie-renew/index.js